define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../models/UserContext", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, UserContext, LookupDataSources) {
    "use strict";
    var CustomersCreationReport = /** @class */ (function () {
        function CustomersCreationReport() {
            this.rangeBy = ko.observable(1);
            this.filterByPlan = ko.observable("");
            this.filterByStatus = ko.observable("");
            this.filterCustomersCreationReportByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterCustomersCreationReportByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.canExport = ko.observable(UserContext.hasAccess("Admin,InternalReports.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
        }
        CustomersCreationReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customers Creation Report");
            tools.ajaxGet({
                url: "/Reports/GetCustomersCreationLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookups = data.Data.lookupLists;
                        self.initGrid(data.Data.GridStructures.CustomersCreationReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomersCreationReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCustomersCreationReportKendo";
            var columns = gridStructure.columns;
            //add actions column
            if (UserContext.hasAccess("Admin")) {
                var actions = {
                    field: "",
                    width: "100px",
                    template: function (dataItem) {
                        var html = "";
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/Customers/Edit/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i>&nbsp;View</a>");
                        return html;
                    }
                };
                columns.push(actions);
            }
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCustomersCreationData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.rangeBy = self.rangeBy();
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByEndDate());
                                data.status = self.filterByStatus();
                                data.planId = self.filterByPlan();
                                if (self.multipleCustomerTypeSelector) {
                                    data.customerTypes = self.multipleCustomerTypeSelector.value().join(",");
                                }
                                if (self.multipleTagsSelector) {
                                    data.tags = self.multipleTagsSelector.value().join(",");
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customersCreationReport-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                },
                enableExport: {
                    entityName: "CustomersCreationReport",
                    title: "Customers Creation Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
            self.multipleCustomerTypeSelector = $("#filterByCustomerTypeInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Customer Types",
                dataTextField: "Text",
                dataValueField: "Value",
                autoClose: false,
                tagMode: "single",
                dataSource: {
                    data: self.lookups.CustomerTypes
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            if (self.multipleCustomerTypeSelector) {
                self.defaultCustomerTypes();
            }
            var lookupDataSources = new LookupDataSources();
            var tagsDS = lookupDataSources.createLookupDataSource("Tags");
            self.multipleTagsSelector = $("#filterByTagInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Tags",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: tagsDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.rangeBy.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterByStatus.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterByPlan.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByStartDate.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByEndDate.subscribe(function () {
                self.reportTable.refresh();
            });
        };
        CustomersCreationReport.prototype.defaultCustomerTypes = function () {
            var self = this;
            var activeStatuses = ko.utils.arrayFilter(self.lookups.CustomerTypes, function (item) {
                return item.Text !== "Internet";
            });
            self.multipleCustomerTypeSelector.value(activeStatuses.map(function (item) {
                return item.Value;
            }));
            self.multipleCustomerTypeSelector.trigger("change");
        };
        CustomersCreationReport.prototype.clearFilter = function () {
            var self = this;
            self.filterCustomersCreationReportByStartDate(DateUtils.firstDayOfMonth());
            self.filterCustomersCreationReportByEndDate(DateUtils.lastDayOfMonth());
            self.rangeBy(1);
            self.filterByStatus("");
            self.filterByPlan("");
            self.defaultCustomerTypes();
            self.multipleTagsSelector.value([]);
            self.multipleTagsSelector.trigger("change");
        };
        CustomersCreationReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return CustomersCreationReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CustomersCreationReportIndex")) {
            log.log("Initialize CustomersCreationReportIndex list");
            $(function () {
                (new CustomersCreationReport()).init();
            });
        }
    }, 0);
    return CustomersCreationReport;
});
//# sourceMappingURL=CustomersCreationReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/customersCreationReport.js
// module id = 255
// module chunks = 2